import { Component, inject, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../../../shared/services/auth.service';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './header.component.html',
})
export class HeaderComponent {
	showBackButton = input(false);
	backPath = input('/app/dashboard');

	router = inject(Router);
	authService = inject(AuthService);

	companyLogo = computed(() => {
		return this.authService.currentUser?.cliente?.logo ?? '';
	});

	companyName = computed(() => {
		return this.authService.currentUser?.titolo ?? '';
	});

	goBack() {
		this.router.navigate([this.backPath()]);
	}
}
